module.exports = __webpack_public_path__ + "media/images/logo_rectangle-bf71fe37e8b2c19671c12d776b974d42.png";